export default __webpack_public_path__ + "static/media/9-breathe.e4d0fd23.png";